import { styled as muiStyled } from '@mui/material/styles'
import styled from '@emotion/styled'
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined'
import { DialogActions, DialogContent, Typography, TypographyProps } from '@mui/material'

export const DialogContentStyled = styled(DialogContent)`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-width: 600px;
  width: 50vw;
  min-height: 350px;
`

export const SuccessMessage = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
`

export const SelectedFilesContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`

export const DialogActionsContainer = styled.div<{ requireApproval: boolean }>`
  height: ${props => (props.requireApproval ? '100px' : 'auto')};
  padding: 0 24px 8px 24px;
`

export const DialogActionsStyled = styled(DialogActions)`
  align-items: center;
  display: flex;
  justify-content: space-between;
`

export const ApprovalTextContainer = styled.div`
  float: right;
  padding-right: 8px;
`

export const FileIcon = styled(InsertDriveFileOutlinedIcon)`
  font-size: 30px;
  margin-right: 8px;
  color: #757575;
`

export const FileDescription = muiStyled(Typography)<TypographyProps>`
  flex-grow: 1;
  color: ${props => props.theme.palette.text.primary};
`

export const ProgressWrapper = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
`

export const iconStyle = {
  fontSize: '70px',
}
